import { Typography } from '@mui/material';
import { ContentSt, FooterSt, versionSt } from './page-footer.styled';
import { IAccount } from 'src/types';

export const BrandedFooter = ({ account }: {account: IAccount;}) =>
<FooterSt id="branded-footer__components-page-footer__footerst__l6" primaryColor={account?.primary_color ?? undefined}>
    <ContentSt id="branded-footer__components-page-footer__contentst__l7">
      {account?.qr_code_logo &&
    <img id="branded-footer__components-page-footer__img__l9"
    alt="Footer logo"
    src={account.qr_code_logo}
    style={{ height: '30px', width: 'auto' }} />

    }

      {account?.footer_url && account?.footer &&
    <a id="branded-footer__components-page-footer__a__l17"
    href={account.footer_url}
    target="_blank"
    rel="noopener noreferrer"
    style={{
      textDecoration: 'underline',
      color: 'inherit',
      display: 'flex',
      alignItems: 'center'
    }}>
      
          <Typography id="branded-footer__components-page-footer__typography__l28"
      className={versionSt}
      style={{
        textDecoration: 'underline',
        fontSize: '12px',
        color: account?.footer_color || 'inherit'
      }}>
        
            {account.footer}
          </Typography>
        </a>
    }

      {!account?.footer_url && account?.footer &&
    <Typography id="branded-footer__components-page-footer__typography__l42"
    className={versionSt}
    style={{ fontSize: '12px', color: account?.footer_color || 'inherit' }}>
      
          {account.footer}
        </Typography>
    }
    </ContentSt>
  </FooterSt>;